













import { Component, Prop, Vue } from 'vue-property-decorator'
import AppForm from '@core/components/AppForm.vue'
import { ClientPolicyDto } from '@core/pages/CommissionModule/api'
import { FormStructure } from '@master/model/structure/FormStructure'
import { options } from '@master/model/options/Options'

@Component({
  components: {
    AppForm
  }
})
export default class EmployeeBenefitPolicyDetailSection extends Vue {
  @Prop({ default: {} }) policyInView: ClientPolicyDto
  @Prop({ default: () => [] }) productOptions: options[]
  @Prop({ default: () => [] }) issuerOptions: options[]
  @Prop({ default: () => [] }) nbrStatusOptions: options[]

  get isDisabled () {
    return this.$store.getters.currentUser.systemrole !== 'ops-staff'
  }

  get subPolicyStructure (): FormStructure<ClientPolicyDto> {
    return [
      {
        label: 'Sub Policy Number',
        model: {
          get: () => this.policyInView.productMetadata.policyNumber,
          set: (val) => {
            this.policyInView.productMetadata.policyNumber = val
          }
        },
        disabled: this.isDisabled
      },
      {
        label: 'Policy Status',
        model: {
          get: () => this.policyInView.productMetadata.productStatus,
          set: (val) => {
            this.policyInView.productMetadata.productStatus = val
          }
        },
        options: [
          { label: '', value: '' },
          { label: 'New Business', value: 'new' },
          { label: 'Renewal', value: 'renewal' },
          { label: 'Lapsed', value: 'lapsed' },
          { label: 'Withdrawn', value: 'withdrawn' }
        ],
        disabled: this.isDisabled
      },
      {
        label: 'Product',
        key: 'productOid',
        options: this.productOptions,
        disabled: this.isDisabled
      },
      {
        label: 'Effective Date',
        key: 'approvedDate',
        type: 'date',
        disabled: this.isDisabled
      },
      {
        label: 'Expiry Date',
        key: 'endDate',
        type: 'date',
        disabled: this.isDisabled
      },
      {
        label: 'NBR Status Date',
        key: 'opsApprovalDate',
        type: 'date',
        disabled: this.isDisabled
      },
      {
        label: 'NBR Application Status',
        key: 'status',
        options: this.nbrStatusOptions,
        disabled: this.isDisabled
      }
    ]
  }
}
